import React from 'react';
import {
  Avatar,
  Fade,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { inputStyle } from '../constants';

const StepPrestation = ({
  formData,
  setFormData,
  categories = [],
  intervenants = [],
  user = {},
}) => {
  return (
    <Fade in>
      <Stack spacing={3} sx={{ mt: 1 }}>
        <TextField
          fullWidth
          label="Nom du soin"
          placeholder="ex: Coaching Performance"
          value={formData.titre_offre || ''}
          onChange={(e) =>
            setFormData({ ...formData, titre_offre: e.target.value })
          }
          sx={inputStyle}
        />

        <TextField
          fullWidth
          multiline
          rows={4}
          label="Description complète"
          placeholder="Détaillez les bénéfices de votre offre..."
          value={formData.description_offre || ''}
          onChange={(e) =>
            setFormData({ ...formData, description_offre: e.target.value })
          }
          sx={inputStyle}
        />

        {/* Sélecteur de catégorie */}
        <TextField
          fullWidth
          select
          label="Catégorie"
          value={formData.id_category || ''}
          onChange={(e) =>
            setFormData({ ...formData, id_category: e.target.value })
          }
          sx={inputStyle}
        >
          {categories.map((c) => (
            <MenuItem
              key={c.id_category}
              value={c.id_category}
              sx={{ py: 1.5, fontWeight: '600', color: '#1B2559' }}
            >
              {c.title_category}
            </MenuItem>
          ))}
          {categories.length === 0 && (
            <MenuItem disabled value="">
              Chargement des catégories...
            </MenuItem>
          )}
        </TextField>

        <TextField
          fullWidth
          type="number"
          label="Durée (min)"
          InputProps={{
            endAdornment: <InputAdornment position="end">min</InputAdornment>,
          }}
          value={formData.duree_offre || ''}
          onChange={(e) =>
            setFormData({ ...formData, duree_offre: e.target.value })
          }
          sx={inputStyle}
        />

        {/* Champ Cible de l'offre (Sécurisé avec || '') */}
        <TextField
          fullWidth
          select
          label="Cible du soin"
          value={formData.cible_offre || ''} // 👈 Sécurisé pour toujours lire la string exacte
          onChange={(e) =>
            setFormData({ ...formData, cible_offre: e.target.value })
          }
          sx={inputStyle}
        >
          <MenuItem value="" disabled>
            <em>Choisir un...</em>
          </MenuItem>
          <MenuItem value="patient_soa">Patient SOA</MenuItem>
          <MenuItem value="client_soa">Client SOA</MenuItem>
          <MenuItem value="tous">Tout le monde</MenuItem>
        </TextField>

        {/* Masqué si l'utilisateur est un Intervenant (3) ou un Praticien (4) */}
        {!['3', '4', 3, 4].includes(user?.role) && (
          <TextField
            fullWidth
            select
            label="Intervenant / Praticien"
            value={formData.id_intervenant || ''}
            onChange={(e) =>
              setFormData({ ...formData, id_intervenant: e.target.value })
            }
            sx={inputStyle}
          >
            {intervenants.map((i) => (
              <MenuItem key={i.id_user} value={i.id_user}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    src={`${process.env.REACT_APP_API_URL}/storage/workshop/${i.photo_user}`}
                    alt={`${i.nom_user} ${i.prenom_user}`}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Typography>
                    {i.nom_user} {i.prenom_user} ({i.role_label})
                  </Typography>
                </Stack>
              </MenuItem>
            ))}
            {intervenants.length === 0 && (
              <MenuItem disabled value="">
                Aucun intervenant ou praticien disponible
              </MenuItem>
            )}
          </TextField>
        )}
      </Stack>
    </Fade>
  );
};

export default StepPrestation;